import React, { useState, useCallback } from 'react';
import NotificationModal from '../components/common/NotificationModal';

// Reemplazo de window.alert/confirm/prompt para todo el sistema.
// Uso:
//   const { notify, confirm, prompt, ModalRenderer } = useModal();
//   await notify('success', 'Listo', 'Guardado correctamente');
//   if (await confirm('¿Eliminar?', 'Esta accion no se puede deshacer')) { ... }
//   const valor = await prompt('Motivo', 'Explica por que', 'Motivo', 'Escribe aqui...');
//   return <>{...}{ModalRenderer}</>;
const useModal = () => {
  const [modal, setModal] = useState(null);
  const closeModal = useCallback(() => setModal(null), []);

  const showModal = useCallback((config) => {
    return new Promise((resolve) => {
      setModal({ ...config, resolve });
    });
  }, []);

  const notify = useCallback((type, title, message) =>
    showModal({ type, title, message }), [showModal]);

  const confirm = useCallback((title, message) =>
    showModal({ type: 'confirm', title, message }), [showModal]);

  const prompt = useCallback((title, message, inputLabel, inputPlaceholder) =>
    showModal({ type: 'prompt', title, message, inputLabel, inputPlaceholder }), [showModal]);

  const ModalRenderer = modal ? (
    <NotificationModal
      type={modal.type}
      title={modal.title}
      message={modal.message}
      inputLabel={modal.inputLabel}
      inputPlaceholder={modal.inputPlaceholder}
      confirmLabel={modal.type === 'confirm' ? 'Confirmar' : modal.type === 'prompt' ? 'Aceptar' : 'Entendido'}
      cancelLabel="Cancelar"
      onConfirm={(val) => { closeModal(); modal.resolve(val !== undefined ? val : true); }}
      onCancel={() => { closeModal(); modal.resolve(false); }}
      onClose={() => { closeModal(); modal.resolve(false); }}
    />
  ) : null;

  return { notify, confirm, prompt, ModalRenderer };
};

export default useModal;
